import { ContractAnnexLine, ContractAnnexLineJson } from '@gi/models/contract-annex-line';
import {
  ContractAnnexModelModelOffer,
  ContractAnnexModelModelOfferJson
} from '@gi/models/contract-annex-model-model-offer';
import { DateHelper } from '@helpers/date.helper';

export interface ContractAnnexModelJson {
  id: number;
  label: string;
  contract_annex_model_lines: Partial<ContractAnnexLineJson>[];
  contract_annex_model_offer_models: Partial<ContractAnnexModelModelOfferJson>[];
  archived_at: string;
}

export class ContractAnnexModel {
  constructor(
    public id?: number,
    public label?: string,
    public contractAnnexModelLines?: ContractAnnexLine[],
    public contractAnnexModelOfferModels?: ContractAnnexModelModelOffer[],
    public archivedAt?: Date
  ) {}

  static fromJson(json: Partial<ContractAnnexModelJson>): ContractAnnexModel {
    return new ContractAnnexModel(
      json.id,
      json.label,
      json.contract_annex_model_lines
        ? json.contract_annex_model_lines.map((lineJson: Partial<ContractAnnexLineJson>) =>
            ContractAnnexLine.fromJson(lineJson)
          )
        : [],
      json.contract_annex_model_offer_models
        ? json.contract_annex_model_offer_models.map((modelJson: ContractAnnexModelModelOfferJson) =>
            ContractAnnexModelModelOffer.fromJson(modelJson)
          )
        : [],
      json.archived_at ? DateHelper.fromUtc(json.archived_at) : null
    );
  }

  static toJson(model: ContractAnnexModel): Omit<ContractAnnexModelJson, 'archived_at'> {
    return {
      id: model.id,
      label: model.label,
      contract_annex_model_lines: model.contractAnnexModelLines?.length
        ? model.contractAnnexModelLines.map((line: ContractAnnexLine) => ContractAnnexLine.toJson(line))
        : [],
      contract_annex_model_offer_models: model.contractAnnexModelOfferModels?.length
        ? model.contractAnnexModelOfferModels.map((model: ContractAnnexModelModelOffer) =>
            ContractAnnexModelModelOffer.toJson(model)
          )
        : []
    };
  }
}
